import TableSearch from "@/components/table_search/TableSearch";
import Header from "../_components/Header";
// import PaginationEl from "../_components/PaginationEl";
import { useState } from "react";
// import { useDebounce } from "@/hooks/useCustomDebounce";
// import { useQuery } from "@tanstack/react-query";
// import api from "@/context/apiRequest";
import { trainnesBreadcrumbList } from "@/l-data/admin/breadcrumLists";
// import ApiError from "@/components/error404/ApiError";
// import TableSkeleton from "@/components/skeletons/TableSkeleton";
import AddElement from "../_components/AddElement";
import AddNewTraineeForm from "./_components/AddNewTraineeForm";
import TraineesTable from "./_components/TraineesTable";
import { traineesData } from "@/l-data/admin/traineesData";

export default function Trainnes() {
  // const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  // const debouncedSearch = useDebounce(search, 1000);
  const [open, setOpen] = useState<boolean>(false);

  // const {
  //   data: Trainnes,
  //   isLoading,
  //   isError,
  // } = useQuery({
  //   queryKey: ["admin-trainees", debouncedSearch, page],
  //   queryFn: async () =>
  //     await api()
  //       .get(`/api/v1/admin/trainee?search=${search}&page=${search ? 1 : page}`)
  //       .then((res) => {
  //         return res?.data?.data;
  //       }),
  // });

  return (
    <main>
      <Header title={"Trainees Data"} list={trainnesBreadcrumbList} />
      <div className="flex items-center justify-between py-6">
        <TableSearch search={search} setSearch={setSearch} />
        <AddElement
          open={open}
          setOpen={setOpen}
          title="Add New Trainee"
          subtitle="Fill all required inputs to add new Trainee"
          formEl={<AddNewTraineeForm setOpen={setOpen} />}
        />
      </div>
      {traineesData && <TraineesTable data={traineesData} />}
      {/* {traineesData && <PaginationEl setPage={setPage} data={Trainnes} />} */}
      {/* {isLoading && <TableSkeleton />} */}
      {/* {isError && <ApiError />} */}
    </main>
  );
}
